var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcknowledged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1397_2584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4335 2.16675H6.56683C3.86411 2.16675 2.51275 2.16675 1.67312 3.00946C0.833496 3.85217 0.833496 5.20849 0.833496 7.92115V8.28081C0.833496 10.9934 0.833496 12.3497 1.67312 13.1925C2.06042 13.5811 2.60507 13.8405 3.30926 13.9706C3.52555 14.0106 3.63369 14.0305 3.68066 14.0983C3.72763 14.1662 3.70834 14.2742 3.66976 14.4901C3.57637 15.013 3.59112 15.4857 3.92641 15.7364C4.2778 15.9929 4.83772 15.7189 5.95757 15.1709C6.0816 15.1101 6.20608 15.0479 6.3308 14.9856L6.3327 14.9846C6.99756 14.6523 7.6751 14.3136 8.39763 14.1467C8.7119 14.0748 9.03183 14.0441 9.4335 14.0351C12.1362 14.0351 13.4876 14.0351 14.3272 13.1925C15.1668 12.3497 15.1668 10.9934 15.1668 8.28081V7.92115C15.1668 5.20849 15.1668 3.85217 14.3272 3.00946C13.4876 2.16675 12.1362 2.16675 9.4335 2.16675ZM11.1668 10.0001C11.1668 10.2762 10.943 10.5001 10.6668 10.5001H5.3335C5.05736 10.5001 4.8335 10.2762 4.8335 10.0001C4.8335 9.72395 5.05736 9.50008 5.3335 9.50008H10.6668C10.943 9.50008 11.1668 9.72395 11.1668 10.0001ZM8.50016 6.66675C8.50016 6.94289 8.2763 7.16675 8.00016 7.16675H5.3335C5.05736 7.16675 4.8335 6.94289 4.8335 6.66675C4.8335 6.39061 5.05736 6.16675 5.3335 6.16675H8.00016C8.2763 6.16675 8.50016 6.39061 8.50016 6.66675Z",
    fill: "#172B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1397_2584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcknowledged);
export default __webpack_public_path__ + "static/media/acknowledged.84283de53fdfeb9599ee4a40de1b5d07.svg";
export { ForwardRef as ReactComponent };